import React, { useState, useEffect, useMemo } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Auth } from 'aws-amplify';
import { useDispatch, useSelector } from 'react-redux';
import {
  DataGridContainer,
  GridContainer,
  LeftGrid,
  NoteHeading,
} from '../../Episode.Styled';
import AuthDialog from './AuthTabDialog';
import {
  AUTHORIZATION_REPORTS_ADMIT_URL,
  AUTHORIZATION_REPORTS_DISCHARGE_URL,
  dateFormat,
  EPISODE_AUTHORIZATION_LIST_URL,
  EPISODE_AUTHORIZATION_PDF_URL,
  EPISODE_AUTHORIZATION_UPDATE_URL,
  TREATMENT_LIST_URL,
} from '../../../../constants';
import { getStopApi } from '../../../../services/StopApi/StopApi';
import { renderCellExpand } from '../../../common/GridCell/GridCellExpand';
import {
  getAuthForm,
  newAuthForm,
} from '../../../../redux/episode/authTab/authFormSlice';
import { getAuthPdfForm } from '../../../../redux/episode/authTab/authPdfSlice';
import {
  getCalOMSAdmitPdfForm,
  resetCalOMSAdmitPdfForm,
} from './CalOMS/store/CalOMSAdmit/CalOMSAdmitAuthPdfSlice';
import {
  getCalOMSDischargePdfForm,
  resetCalOMSDischargePdfForm,
} from './CalOMS/store/CalOMSDischarge/CalOMSDischargeAuthPdfSlice';

const AuthTab = (props) => {
  //console.log('### props.episodeHeader')
  //console.log(props.episodeHeader)
  const episodeHeaderData = props.episodeHeaderData;
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [openAuthDialog, setOpenAuthDialog] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [authData, setAuthData] = useState({
    isLoading: false,
    data: [],
    pageSize: 10,
    total: 0,
    page: 1,
  });
  const [cbpData, setCbpData] = useState({
    isLoading: false,
    data: [],
    pageSize: 10,
    total: 0,
    // page: 1,
  });
  const [treatments, setTreatments] = useState([]);

  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );
  const episodeReferralSource = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.referralSource
  );
  const episodeInactivity = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.inactivity
  );
  //console.log('episodeReferralSource')
  //console.log(episodeReferralSource)
  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchAuthList();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    authData.page,
    authData.pageSize,
    cbpData.pageSize,
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const fetchAuthList = async () => {
    //console.log('### FETCH DATA (AUTH LIST) EPISODE AUTH');
    setAuthData((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${EPISODE_AUTHORIZATION_LIST_URL}/${episodeId}/authList?PageNumber=${authData.page}&PageSize=${authData.pageSize}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response.data;
      setAuthData((prveState) => ({
        ...prveState,
        isLoading: false,
        total: response.totalRows,
        data: json?.map((item, index) => ({
          ...item,
          id: item.authId,
          authStartDate: item.authStartDate
            ? moment(item.authStartDate).format(dateFormat).split('T')[0]
            : '-',
          overAllEndDate: item.overAllEndDate
            ? moment(item.overAllEndDate).format(dateFormat).split('T')[0]
            : '-',
          modality: item.modality ? item.modality?.value : '-',
          communityBasedProvider: item.communityBasedProvider
            ? item.communityBasedProvider?.value
            : '-',
          cbpAdmitDate: item.cbpAdmitDate
            ? moment(item.cbpAdmitDate).format(dateFormat).split('T')[0]
            : '-',
          cbpDischargeDate: item.cbpDischargeDate
            ? moment(item.cbpDischargeDate).format(dateFormat).split('T')[0]
            : '-',
          dischargeReason: item.dischargeReason
            ? item.dischargeReason?.value
            : '-',
          totalTreatmentVerified: item.totalTreatmentVerified
            ? item.totalTreatmentVerified
            : '-',

          cboName: item.cboName,
          cboModId: item.cboModId,
          orgAdr: item.orgAdr,
          orgCity: item.orgCity,
          orgZip: item.orgZip,
          cntKey: item.cntKey,
          cntFax: item.cntFax,
          cntPhone: item.cntPhone,
        })),
      }));
    }).catch((e) => alert(e));
  };

  const fetchAuth = async (authId, openBackdrop) => {
    let commonParams = `${EPISODE_AUTHORIZATION_UPDATE_URL}/${authId}`;
    const pdfUrl = `${EPISODE_AUTHORIZATION_PDF_URL}/${authId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getAuthForm({ commonParams, authorization }));
    setCbpData((prveState) => ({ ...prveState, isLoading: true }));

    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response?.data?.episodeAuthAuthCBO;
      setCbpData((prveState) => ({
        ...prveState,
        isLoading: false,
        data: json?.map((item, index) => ({
          ...item,
          _id: index,
          cboAthId: item.cboAthId,
          authStartDate: item.authStartDate
            ? moment(item.authStartDate).format(dateFormat).split('T')[0]
            : '-',
          dayQuantity: item.dayQuantity,
          authEndDate: item.authEndDate
            ? moment(item.authEndDate).format(dateFormat).split('T')[0]
            : '-',
        })),
      }));
    }).catch((e) => alert(e));

    commonParams = `${TREATMENT_LIST_URL}/${authId}`;
    getStopApi({ commonParams, authorization }).then((response) => {
      setTreatments(response?.data?.treatments);
    }).catch((e) => alert(e));

    dispatch(getAuthPdfForm({ pdfUrl, authorization }));
    if (openBackdrop) {
      setOpenBackdrop(true);
      setTimeout(() => {
        setOpenBackdrop(false);
      }, 500);
    }
    //console.log(authData);
    setOpenAuthDialog(true);
  };

  const fetchAdmit = (authId) => {
    const pdfUrl = `${AUTHORIZATION_REPORTS_ADMIT_URL}/${authId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getCalOMSAdmitPdfForm({ pdfUrl, authorization }));
  };

  const fetchDischarge = (authId) => {
    const pdfUrl = `${AUTHORIZATION_REPORTS_DISCHARGE_URL}/${authId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getCalOMSDischargePdfForm({ pdfUrl, authorization }));
  };
  const authRowClick = (rowData) => {
    fetchAuth(rowData.id, true);
    fetchAdmit(rowData.id);
    fetchDischarge(rowData.id);
  };

  const handelNewAuthForm = () => {
    const newEmptyAuthForm = {
      newAuthForm: true,
      authId: 0,
      sapAthEpdId: episodeId,
      modality: '',
      communityBasedProvider: '',
      budgetType: 'STOP',
      authType: '',
      fundingOrg: '',
      transferForm: '',
      initialReferral: '',
      athIssueDate: '',
      ext1IssueDate: '',
      ext2IssueDate: '',
      authorizedByOriginal: '',
      authorizedByExtension1: '',
      authorizedByExtension2: '',
      daysAuthorisedStartDate: '',
      ext1StartDate: '',
      ext2StartDate: '',
      daysAuthorisedQty: '',
      ext1DayQty: '',
      ext2DayQty: '',
      daysAuthorisedDayDelay: '',
      daysAuthorisedEndDate: '',
      ext1EndDate: '',
      ext2EndDate: '',
      overAllStartDate: '',
      overallQty: '',
      overAllEndDate: '',
      unitsTotal: '',
      maxUnitsPerWeek: '',
      maxIndsPerWeek: '',
      maxGrpsPerWeek: '',
      cbpAdmitDate: '',
      cbpDischargeDate: '',
      authStartDate: '',
      authEndDate: '',
      placementType: '',
      relapse: '',
      authComment: '',
      completionSurveyAdministered: '',
      authIsLocked: '',
      administrativeTransferAdmit: '',
      authorizationReviewedBy: '',
      reviewDate: '',
    };
    dispatch(newAuthForm(newEmptyAuthForm));
    dispatch(resetCalOMSDischargePdfForm());
    dispatch(resetCalOMSAdmitPdfForm());
    setOpenAuthDialog(true);
  };
  const authColumnsData = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'Auth ID',
        sortable: false,
        flex: 1,
      },
      {
        field: 'authStartDate',
        headerName: 'Auth Start',
        sortable: false,
        type: 'date',
        minWidth: 80,
        flex: 1,
      },
      {
        field: 'overAllEndDate',
        headerName: 'Auth Overall End',
        sortable: false,
        type: 'date',
        minWidth: 80,
        flex: 1,
      },
      {
        field: 'modality',
        headerName: 'Modality',
        sortable: false,
        renderCell: renderCellExpand,
        flex: 1,
      },
      {
        field: 'communityBasedProvider',
        headerName: 'Community Based Program',
        sortable: false,
        minWidth: 250,
        renderCell: renderCellExpand,
        flex: 1,
      },
      {
        field: 'cbpAdmitDate',
        headerName: 'CBP Admit',
        sortable: false,
        type: 'date',
        minWidth: 80,
        flex: 1,
      },
      {
        field: 'cbpDischargeDate',
        headerName: 'CBP Discharge Date',
        sortable: false,
        type: 'date',
        minWidth: 80,
        flex: 1,
      },
      {
        field: 'dischargeReason',
        headerName: 'CBP Discharge Reason',
        minWidth: 120,
        sortable: false,
        flex: 1,
      },
      {
        field: 'totalTreatmentVerified',
        headerName: 'Total Treatement Verified',
        sortable: false,
      },
    ],
    [user]
  );

  return (
    <>
      <GridContainer container>
        <Grid item xs={6}>
          <NoteHeading variant="h5">
            {authData.total > 0 ? 'To edit auth please click on a row' : ''}
          </NoteHeading>
        </Grid>
        <LeftGrid item xs={6}>
          {episodeInactivity ? (
            <NoteHeading variant="h5">Episode Inactive</NoteHeading>
          ) : (
            <Button variant="contained" onClick={() => handelNewAuthForm()}>
              New Authorization
            </Button>
          )}
        </LeftGrid>
      </GridContainer>
      <DataGridContainer>
        <div style={{ height: 480, width: '100%' }}>
          <div style={{ display: 'flex', height: '100%' }}>
            <div style={{ flexGrow: 1 }}>
              <DataGrid
                //getRowHeight={() => 'auto'}
                columns={authColumnsData}
                rows={authData.data}
                rowCount={authData.total}
                rowsPerPageOptions={[10, 25, 50]}
                pageSize={authData.pageSize}
                pagination
                paginationMode="server"
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }
                onPageSizeChange={(newPageSize) =>
                  setAuthData((prveState) => ({
                    ...prveState,
                    pageSize: newPageSize,
                  }))
                }
                onPageChange={(newPage) => {
                  setAuthData((prveState) => ({
                    ...prveState,
                    page: newPage + 1,
                  }));
                }}
                loading={authData.isLoading}
                onRowClick={(param) => authRowClick(param.row)}
                disableColumnFilter
                disableColumnMenu
              />
            </div>
          </div>
        </div>      

      </DataGridContainer>
      <AuthDialog
        open={openAuthDialog}
        setOpen={setOpenAuthDialog}
        authToken={user?.signInUserSession.accessToken.jwtToken}
        // episodeId={episodeId}
        authData={authData}
        cbpData={cbpData}
        treatments={treatments}
        openBackdrop={openBackdrop}
        fetchAuthList={fetchAuthList}
        fetchAuth={fetchAuth}
        episodeReferralSource={episodeReferralSource}
        episodeHeaderData = {episodeHeaderData}
      />
    </>
  );
};
export default AuthTab;
